import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import _ from 'lodash';
import cx from 'classnames';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import qs from 'query-string';
import i18n from 'i18next';
import { List, ListItem, Collapse } from '@material-ui/core';
import ToggleBtn from 'ui/components/toggle-button';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'font-gorilla/css/font-gorilla.css';
import 'purecss/build/pure-min.css'; // import 'f2eUI/css/react-ui-dark.css'
// import 'react-ui/build/css/react-ui.css'
// import 'react-chart/build/css/react-chart.css'

import { AccountCircleOutlined, QuestionAnswerOutlined } from '@material-ui/icons';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import MenuIcon from '@material-ui/icons/Menu';
import Slide from '@material-ui/core/Slide';
import Drawer from '@material-ui/core/Drawer';
import { changeTitle } from './routes';
import { PAGESITS } from '../consts/display';
import { setSession } from '../redux/session';
import { locationChange, setRights } from '../redux/router';
import { setEnvCfg } from '../redux/env-cfg';
import ah from '../utils/ajax-helper';
import logger from '../utils/logger';
import moment from 'moment'; // import { create as createAuth, auth } from '../utils/auth-helper'

import { initWebSocket, getWebSocket } from './websocket';
import ResetPassword from './reset-password';
import TerminalsRelated from './system/terminalsRelated';
import LogisticsRelated from './system/logisticsRelated';
import SideNavMenu from './sideNavMenu';
import { AuditLogStatistics, AuditLogStatisticsSearch } from './auditLogStatistics';
import Marquees from './ui/marquees-test';
import Progress from './ui/react-ui/progress.jsx';
import LoginDialog from './ui/login-dialog';
import AuditLogErrorMessage from './ui/auditLogErrorMessage';
import FeedbackEdit from './setting/feedback-edit.js'; // api

import { getBillboardTypeList } from '../api/settingAPI';
import { getMessageListNotEnd } from '../api/messageAPI';
import { getLogistics } from '../api/freightAPI';
import { getAreaZones, getAreaTerminals, getAreaGates } from '../api/areaAPI';
import { getFeedbackDescriptionAPI } from '../api/settingAPI'; // redux

import { setMarqueesData, setZonesList, setTerminalsList, setZonesListData, setLogisticsList, setOpenSideMenu, setOpenTrafficLiveTab, setIsMobileDevice, setAllTerminalsList, setAllLogisticsList, setGateList, setAuditLogError, setFeedbackDescription } from '../redux/app'; // const log = require('loglevel').getLogger('Main App')

var t = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');

var Header = /*#__PURE__*/function (_React$Component) {
  _inherits(Header, _React$Component);

  var _super = _createSuper(Header);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _super.call(this, props);
    _this.state = {
      hoverActive: false,
      resetPasswordUserName: '',
      showSystemConfig: false,
      lngSelectExpand: false,
      openMobileMenu: false // openLoginDialog: false

    }; // this.initEventWebSocket()

    return _this;
  }

  _createClass(Header, [{
    key: "handleAlarmSoundToggle",
    value: function handleAlarmSoundToggle(alarmSoundOn) {
      var onAlarmSoundChange = this.props.onAlarmSoundChange;
      onAlarmSoundChange(alarmSoundOn);
    }
  }, {
    key: "handleHover",
    value: function handleHover(url, e) {
      this.setState({
        hoverActive: true
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        hoverActive: false
      });
    }
  }, {
    key: "handleConfigClick",
    value: function handleConfigClick(e) {
      e.preventDefault();
      this.setState({
        showSystemConfig: true
      });
    }
  }, {
    key: "handleConfigClose",
    value: function handleConfigClose() {
      this.setState({
        showSystemConfig: false,
        lngSelectExpand: false
      });
    }
  }, {
    key: "handleResetPassword",
    value: function handleResetPassword() {
      // this.setState({
      //     resetPasswordUserName: ''
      // })
      this.props.onRestPassword();
    }
  }, {
    key: "handleResetPasswordClick",
    value: function handleResetPasswordClick(e) {
      e.preventDefault();
      this.props.onRestPasswordClick(); // this.setState({
      //     resetPasswordUserName: this.props.session.userName
      // })
    }
  }, {
    key: "handleLngSelectClick",
    value: function handleLngSelectClick() {
      this.setState({
        lngSelectExpand: !this.state.lngSelectExpand
      });
    }
  }, {
    key: "handleLngChange",
    value: function handleLngChange(lng) {
      i18n.changeLanguage(lng);
    }
  }, {
    key: "handleAlarmMessageData",
    value: function handleAlarmMessageData(data) {
      this.props.onAlarmMessage(data);
    } // initEventWebSocket() {
    //     const socket = getWebSocket()
    //     socket.on('message', this.handleAlarmMessageData.bind(this))
    // }

  }, {
    key: "handleRelatedTerminalsEditor",
    value: function handleRelatedTerminalsEditor(e) {
      e.preventDefault();
      this.props.onOepnTerminalsRelatedEditor();
    }
  }, {
    key: "handleRelatedLogisticsEditor",
    value: function handleRelatedLogisticsEditor(e) {
      e.preventDefault();
      this.props.onOpenLogisticsRelatedEditor();
    }
  }, {
    key: "handleOpenLoginDialog",
    value: function handleOpenLoginDialog(e) {
      e.preventDefault();
      this.props.onOpenLoginDialog();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$context = this.context,
          rights = _this$context.rights,
          contextRoot = _this$context.contextRoot,
          isManagementMode = _this$context.isManagementMode;
      var _this$props = this.props,
          session = _this$props.session,
          alarmSoundOn = _this$props.alarmSoundOn,
          openSideMenu = _this$props.openSideMenu,
          marqueesData = _this$props.marqueesData,
          onOpenMobileMenu = _this$props.onOpenMobileMenu;
      var _this$state = this.state,
          hoverActive = _this$state.hoverActive,
          openLoginDialog = _this$state.openLoginDialog;
      return /*#__PURE__*/React.createElement("header", {
        id: "g-header",
        className: cx('c-flex aic', {
          'closeSideMenu': !openSideMenu
        })
      }, /*#__PURE__*/React.createElement("div", {
        id: "mobile-menu",
        onClick: function onClick() {
          return onOpenMobileMenu();
        }
      }, /*#__PURE__*/React.createElement(MenuIcon, {
        iconStyle: {
          width: 32,
          height: 32
        }
      })), /*#__PURE__*/React.createElement("div", {
        id: "heading"
      }, /*#__PURE__*/React.createElement("h2", null, isManagementMode ? t('title') : t('front-platform-title'))), /*#__PURE__*/React.createElement("div", {
        className: "latest-news"
      }, /*#__PURE__*/React.createElement(Marquees, {
        dataList: marqueesData
      })), /*#__PURE__*/React.createElement("div", {
        id: "account-menu",
        role: "presentation",
        className: cx('end', {
          active: hoverActive
        }),
        onMouseOver: this.handleHover.bind(this),
        onMouseOut: this.handleBlur.bind(this)
      }, /*#__PURE__*/React.createElement("a", {
        role: "menuitem",
        onClick: function onClick(e) {
          return e.preventDefault();
        }
      }, /*#__PURE__*/React.createElement(AccountCircleOutlined, {
        className: "user-icon"
      }), /*#__PURE__*/React.createElement("div", null, session.name)), /*#__PURE__*/React.createElement("ul", {
        className: "g-submenu"
      }, (isManagementMode || session.username !== 'guest') && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: "c-link",
        id: "resetPassword"
      }, /*#__PURE__*/React.createElement("a", {
        href: "".concat(contextRoot, "/reset-password"),
        onClick: this.handleResetPasswordClick.bind(this)
      }, t('login.reset-password')))), _.includes(rights, 'evms.terminalConfig') && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: "c-link",
        id: "relatedTerminals"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: this.handleRelatedTerminalsEditor.bind(this)
      }, t('setting.lbl-terminals-related')))), _.includes(rights, 'evms.logisticConfig') && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: "c-link",
        id: "relatedLogistics"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: this.handleRelatedLogisticsEditor.bind(this)
      }, t('setting.lbl-logistics-related')))), /*#__PURE__*/React.createElement("li", {
        className: "separator"
      }, !isManagementMode && session.username === 'guest' ? /*#__PURE__*/React.createElement("span", {
        className: "c-link",
        id: "login"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: this.handleOpenLoginDialog.bind(this)
      }, t('login.lbl-login'))) : /*#__PURE__*/React.createElement("span", {
        className: "c-link",
        id: "logout"
      }, /*#__PURE__*/React.createElement("a", {
        href: "".concat(contextRoot, "/logout"),
        onClick: function onClick() {
          return Progress.startSpin();
        }
      }, t('login.logout')))))));
    }
  }]);

  return Header;
}(React.Component);

Header.contextTypes = {
  rights: PropTypes.arrayOf(PropTypes.string),
  query: PropTypes.object,
  contextRoot: PropTypes.string,
  isManagementMode: PropTypes.bool
};
Header.propTypes = {
  session: PropTypes.object,
  alarmSoundOn: PropTypes.bool,
  onAlarmSoundChange: PropTypes.func
};

var Footer = function Footer(_ref) {
  var copyright = _ref.copyright,
      version = _ref.version;
  return /*#__PURE__*/React.createElement("footer", {
    id: "g-footer"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: "copyright"
  }, copyright), /*#__PURE__*/React.createElement("span", {
    className: "version"
  }, version)));
};

Footer.propTypes = {
  copyright: PropTypes.string,
  version: PropTypes.string
};

var App = /*#__PURE__*/function (_React$Component2) {
  _inherits(App, _React$Component2);

  var _super2 = _createSuper(App);

  function App(props) {
    var _this2;

    _classCallCheck(this, App);

    _this2 = _super2.call(this, props);

    _this2.setAjaxPrefilter();

    _this2.props.history.listen(function (location, action) {
      _this2.props.onLocationChange(location, action);
    });

    var _props$session = props.session,
        id = _props$session.id,
        userName = _props$session.userName,
        alarmLevels = _props$session.alarmLevels,
        menus = _props$session.menus,
        rights = _props$session.rights;
    _this2.state = {
      info: null,
      error: false,
      menus: menus,
      rights: rights,
      pages: PAGESITS,
      marqueesData: [],
      openMobileMenu: false,
      resetPasswordUserName: '',
      openTerminalsRelatedEditor: false,
      openLogisticsRelatedEditor: false,
      openLoginDialog: false,
      openAuditLogStatisticsDialog: false,
      feedbackDialogData: {
        mode: '',
        data: {}
      }
    };
    _this2.pollingTimer = null;
    initWebSocket(id, userName, alarmLevels);
    return _this2;
  }

  _createClass(App, [{
    key: "getCurrentPage",
    value: function getCurrentPage() {
      var location = this.props.location;
      var pages = this.state.pages;
      if (!location) return null;

      var currentPage = _(pages).filter(function (val) {
        if (location.pathname.indexOf(val.url) >= 0) {
          return true;
        }

        return false;
      }).sortBy(function (el) {
        return 0 - el.url.length;
      }).take(1).value();

      return currentPage;
    }
  }, {
    key: "setAjaxPrefilter",
    value: function setAjaxPrefilter() {
      var contextRoot = this.props.contextRoot;
      $.ajaxPrefilter('json', function (options, originalOptions, jqXHR) {
        jqXHR.promise().then(function (res) {
          if (res.code < 0) res.error = et(res.messageCode) === _.toString(res.messageCode) ? res.message : et(res.messageCode);
          if (res.code === '-00001' || res.code === '-00002') top.location.href = contextRoot;
        }).catch(function (err) {
          err.message = et('-00003');
        });
      });
    }
  }, {
    key: "changeUser",
    value: function changeUser(data) {
      this.props.onSessionChange(data);
    }
  }, {
    key: "detecIsMobileDevice",
    value: function detecIsMobileDevice() {
      var mobileDevice = ['Android', 'webOS', 'iPhone', 'iPad', 'iPod', 'BlackBerry', 'Windows Phone'];
      var isMobileDevice = mobileDevice.some(function (e) {
        return navigator.userAgent.match(e);
      });
      return isMobileDevice;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          contextRoot = _this$props2.contextRoot,
          onSetEnvCfg = _this$props2.onSetEnvCfg,
          onGetAreaZones = _this$props2.onGetAreaZones,
          onGetAreaTerminals = _this$props2.onGetAreaTerminals,
          onGetLogistics = _this$props2.onGetLogistics,
          onGetAreaGates = _this$props2.onGetAreaGates,
          onGetMessageList = _this$props2.onGetMessageList,
          onCloseTrafficLiveTab = _this$props2.onCloseTrafficLiveTab,
          onSetIsMobileDevice = _this$props2.onSetIsMobileDevice,
          onGetBillboardTypeList = _this$props2.onGetBillboardTypeList,
          onGetAllAreaTerminals = _this$props2.onGetAllAreaTerminals,
          onGetAllLogistics = _this$props2.onGetAllLogistics,
          onGetFeedbackDescription = _this$props2.onGetFeedbackDescription;
      this.refreshRights();
      onSetEnvCfg(contextRoot);
      onGetAreaZones(contextRoot);
      onGetAreaTerminals(contextRoot);
      onGetAllAreaTerminals(contextRoot);
      onGetLogistics(contextRoot);
      onGetAllLogistics(contextRoot);
      onGetMessageList(contextRoot);
      onGetAreaGates(contextRoot);
      onGetFeedbackDescription(contextRoot);
      this.handlePollingMessage();

      if (this.detecIsMobileDevice()) {
        onCloseTrafficLiveTab();
        onSetIsMobileDevice();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var location = this.props.location;
      if (!_.isEqual(location, prevProps.location)) this.refreshRights();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.pollingTimer);
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      var _this$props3 = this.props,
          session = _this$props3.session,
          contextRoot = _this$props3.contextRoot,
          location = _this$props3.location,
          query = _this$props3.query,
          openSideMenu = _this$props3.openSideMenu,
          isManagementMode = _this$props3.isManagementMode;
      var _this$state2 = this.state,
          menus = _this$state2.menus,
          rights = _this$state2.rights,
          pages = _this$state2.pages;
      var path = this.context.path;
      return {
        path: path,
        menus: menus,
        rights: rights,
        pages: pages,
        userId: session && session.id,
        userName: session && session.userName,
        displayName: session && session.displayName,
        contextRoot: contextRoot,
        location: location,
        query: query,
        isManagementMode: isManagementMode
      };
    } // handleWebsocketAlarmMessage(data) {
    //     const { onSetMarqueesData, marqueesData } = this.props
    //     let newMarqueesData = _.cloneDeep(marqueesData)
    //     let isRemove = _.find(marqueesData, el => el.id === data.id)
    //     if(isRemove) {
    //         _.remove(newMarqueesData, el => el.id === data.id)
    //     } else {
    //         if(!data.isPublished || moment(data.endTime).valueOf() < moment().valueOf())
    //             return
    //         newMarqueesData.push({
    //             id: data.id,
    //             title: data.title,
    //             description: data.description,
    //             source: data.source,
    //             type: data.type
    //         })
    //     }
    //     onSetMarqueesData(newMarqueesData)
    // }

  }, {
    key: "handlePollingMessage",
    value: function handlePollingMessage() {
      var _this$props4 = this.props,
          onGetMessageList = _this$props4.onGetMessageList,
          contextRoot = _this$props4.contextRoot;
      this.pollingTimer = setInterval(function () {
        onGetMessageList(contextRoot);
      }, 10 * 1000);
    }
  }, {
    key: "logout",
    value: function logout() {
      ah.post('api/logout').finally(function () {
        document.location.reload();
      });
    }
  }, {
    key: "refreshRights",
    value: function refreshRights() {
      var _this$props5 = this.props,
          onSetRights = _this$props5.onSetRights,
          session = _this$props5.session,
          onSetAuditLogErrorTrue = _this$props5.onSetAuditLogErrorTrue;
      var orgRights = this.state.rights;
      var rights = [];
      var currentPage = this.getCurrentPage();

      if (currentPage && currentPage[0]) {
        var key = _.filter(currentPage[0].url.split('/'), function (el) {
          return el;
        }).join('.');

        rights = _.filter(orgRights, function (o) {
          return _.endsWith(o, '_' + key);
        });
        rights = _.map(rights, function (o) {
          return _.toLower(_.replace(o, '_' + key, ''));
        });
        logger('view', t('logger.target-menu')).then(function (result) {
          if (session.username === 'admin' && result.code < 0) onSetAuditLogErrorTrue();
        }).catch(function (error) {
          if (session.username === 'admin') onSetAuditLogErrorTrue();
        });
      }

      onSetRights(rights);
    }
  }, {
    key: "handleOepnMobileMenu",
    value: function handleOepnMobileMenu() {
      var openMobileMenu = this.state.openMobileMenu;
      this.setState({
        openMobileMenu: !openMobileMenu
      });
    }
  }, {
    key: "handleResetPassword",
    value: function handleResetPassword() {
      this.setState({
        resetPasswordUserName: ''
      });
    }
  }, {
    key: "handleResetPasswordClick",
    value: function handleResetPasswordClick(e) {
      e.preventDefault();
      this.setState({
        resetPasswordUserName: this.props.session.username
      });
    }
  }, {
    key: "handleRelatedTerminalsEditor",
    value: function handleRelatedTerminalsEditor() {
      this.setState({
        openTerminalsRelatedEditor: !this.state.openTerminalsRelatedEditor
      });
    }
  }, {
    key: "handleRelatedLogisticsEditor",
    value: function handleRelatedLogisticsEditor() {
      this.setState({
        openLogisticsRelatedEditor: !this.state.openLogisticsRelatedEditor
      });
    }
  }, {
    key: "handleOpenLoginDialog",
    value: function handleOpenLoginDialog() {
      this.setState({
        openLoginDialog: !this.state.openLoginDialog
      });
    }
  }, {
    key: "handleOpenAuditLogStatisticsSearchDialog",
    value: function handleOpenAuditLogStatisticsSearchDialog() {
      this.setState({
        openAuditLogStatisticsDialog: !this.state.openAuditLogStatisticsDialog,
        openMobileMenu: false
      });
    }
  }, {
    key: "openFeedbackDialog",
    value: function openFeedbackDialog() {
      this.setState({
        feedbackDialogData: {
          mode: 'read',
          data: {
            description: this.props.feedbackDescription
          }
        }
      });
    }
  }, {
    key: "closeFeedbackDailog",
    value: function closeFeedbackDailog() {
      this.setState({
        feedbackDialogData: {
          mode: '',
          data: {}
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props6 = this.props,
          copyright = _this$props6.copyright,
          version = _this$props6.version,
          marqueesData = _this$props6.marqueesData,
          session = _this$props6.session,
          children = _this$props6.children,
          location = _this$props6.location,
          alarmSoundOn = _this$props6.alarmSoundOn,
          contextRoot = _this$props6.contextRoot,
          onSetOpenSideMenu = _this$props6.onSetOpenSideMenu,
          openSideMenu = _this$props6.openSideMenu,
          isManagementMode = _this$props6.isManagementMode,
          auditLogError = _this$props6.auditLogError;
      var _this$state3 = this.state,
          menus = _this$state3.menus,
          rights = _this$state3.rights,
          openMobileMenu = _this$state3.openMobileMenu,
          resetPasswordUserName = _this$state3.resetPasswordUserName,
          openTerminalsRelatedEditor = _this$state3.openTerminalsRelatedEditor,
          openLogisticsRelatedEditor = _this$state3.openLogisticsRelatedEditor,
          openLoginDialog = _this$state3.openLoginDialog,
          openAuditLogStatisticsDialog = _this$state3.openAuditLogStatisticsDialog,
          feedbackDialogData = _this$state3.feedbackDialogData;
      var params = new URLSearchParams(location.search);
      var fullscreen = params.get('fullscreen'); // Determine title

      var currentPage = this.getCurrentPage();

      if (currentPage && currentPage[0]) {
        var urlComps = _.filter(currentPage[0].url.split('/'), function (el) {
          return el;
        });

        var title = '';

        if (urlComps.length > 0) {
          var noWebMenus = _.filter(menus, function (el) {
            return el.key.indexOf('web.') === -1;
          });

          _.forEach(noWebMenus, function (item) {
            if (item.key.indexOf(urlComps[0]) >= 0) {
              if (urlComps.length > 1) {
                title = t('menu.side.' + urlComps[0] + '.' + urlComps[1]);
              } else if (urlComps.length === 1) {
                title = t('menu.side.' + urlComps[0] + '.title');
              }
            }

            return title;
          });
        }

        changeTitle(title, null, isManagementMode);
      }

      return /*#__PURE__*/React.createElement("div", {
        id: "g-app",
        className: cx({
          'fullscreen': fullscreen
        })
      }, /*#__PURE__*/React.createElement(Header, {
        marqueesData: marqueesData,
        session: session,
        openSideMenu: openSideMenu // onAlarmMessage={this.handleWebsocketAlarmMessage.bind(this)}
        ,
        onOpenMobileMenu: this.handleOepnMobileMenu.bind(this),
        onOepnTerminalsRelatedEditor: this.handleRelatedTerminalsEditor.bind(this),
        onOpenLogisticsRelatedEditor: this.handleRelatedLogisticsEditor.bind(this),
        onOpenLoginDialog: this.handleOpenLoginDialog.bind(this),
        onRestPasswordClick: function onRestPasswordClick() {
          return _this3.setState({
            resetPasswordUserName: session.username
          });
        },
        onRestPassword: function onRestPassword() {
          return _this3.setState({
            resetPasswordUserName: ''
          });
        }
      }), /*#__PURE__*/React.createElement(Drawer, {
        open: openMobileMenu,
        onClose: this.handleOepnMobileMenu.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "mobile-side-nav"
      }, /*#__PURE__*/React.createElement("img", {
        className: cx('ticp-logo'),
        src: "".concat(contextRoot, "/images/tipc-logo.png")
      }), /*#__PURE__*/React.createElement(SideNavMenu, {
        isManagementMode: isManagementMode,
        session: session,
        location: location,
        openSideMenu: true,
        onMobileMenuClick: this.handleOepnMobileMenu.bind(this)
      }, /*#__PURE__*/React.createElement(React.Fragment, null, (isManagementMode || session.username !== 'guest') && /*#__PURE__*/React.createElement("li", {
        className: "menu-item-extra"
      }, /*#__PURE__*/React.createElement("div", {
        className: "hr-line-extra"
      }), /*#__PURE__*/React.createElement("i", {
        className: "fas fa-redo urlIcon"
      }), /*#__PURE__*/React.createElement("span", {
        className: "c-link",
        id: "resetPassword"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: function onClick(e) {
          _this3.handleOepnMobileMenu();

          _this3.handleResetPasswordClick(e);
        }
      }, t('login.reset-password')))), _.includes(rights, 'evms.terminalConfig') && /*#__PURE__*/React.createElement("li", {
        className: "menu-item-extra"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-building urlIcon"
      }), /*#__PURE__*/React.createElement("span", {
        className: "c-link",
        id: "relatedTerminals"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: function onClick(e) {
          e.preventDefault();

          _this3.handleOepnMobileMenu();

          _this3.handleRelatedTerminalsEditor(e);
        }
      }, t('setting.lbl-terminals-related')))), _.includes(rights, 'evms.logisticConfig') && /*#__PURE__*/React.createElement("li", {
        className: "menu-item-extra"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-link urlIcon"
      }), /*#__PURE__*/React.createElement("span", {
        className: "c-link",
        id: "relatedLogistics"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: function onClick(e) {
          e.preventDefault();

          _this3.handleOepnMobileMenu();

          _this3.handleRelatedLogisticsEditor(e);
        }
      }, t('setting.lbl-logistics-related')))), /*#__PURE__*/React.createElement("li", {
        className: "menu-item-extra"
      }, !isManagementMode && session.username === 'guest' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "hr-line-extra"
      }), /*#__PURE__*/React.createElement("i", {
        className: "fas fa-sign-in-alt urlIcon"
      }), /*#__PURE__*/React.createElement("span", {
        className: "c-link",
        id: "login"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: function onClick(e) {
          e.preventDefault();

          _this3.handleOepnMobileMenu();

          _this3.handleOpenLoginDialog(e);
        }
      }, t('login.lbl-login')))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-sign-out-alt urlIcon"
      }), /*#__PURE__*/React.createElement("span", {
        className: "c-link",
        id: "logout"
      }, /*#__PURE__*/React.createElement("a", {
        href: "".concat(contextRoot, "/logout"),
        onClick: function onClick() {
          return Progress.startSpin();
        }
      }, t('login.logout'))))), isManagementMode && _.includes(rights, 'evms.audit.log.statistics') && /*#__PURE__*/React.createElement(AuditLogStatistics, {
        onClick: this.handleOpenAuditLogStatisticsSearchDialog.bind(this)
      }))))), openAuditLogStatisticsDialog && /*#__PURE__*/React.createElement(AuditLogStatisticsSearch, {
        onClose: this.handleOpenAuditLogStatisticsSearchDialog.bind(this)
      }), /*#__PURE__*/React.createElement("div", {
        id: "g-side-nav",
        className: cx(openSideMenu ? 'open' : 'close')
      }, /*#__PURE__*/React.createElement("img", {
        className: cx('ticp-logo', {
          'show': openSideMenu
        }),
        src: "".concat(contextRoot, "/images/tipc-logo.png")
      }), /*#__PURE__*/React.createElement("img", {
        className: cx('ticp-icon', {
          'show': !openSideMenu
        }),
        src: "".concat(contextRoot, "/images/tipc-icon.png")
      }), /*#__PURE__*/React.createElement(SideNavMenu, {
        isManagementMode: isManagementMode,
        session: session,
        location: location,
        openSideMenu: openSideMenu
      }, !isManagementMode && /*#__PURE__*/React.createElement("div", {
        className: "front-block"
      }, /*#__PURE__*/React.createElement("div", {
        className: "qrcode-block"
      }, /*#__PURE__*/React.createElement("img", {
        src: "".concat(contextRoot, "/images/qr-code.png"),
        width: "85",
        height: "85"
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", null, "\u7ACB\u5373\u4E0B\u8F09APP"))), /*#__PURE__*/React.createElement("div", {
        className: "feedback-block",
        onClick: this.openFeedbackDialog.bind(this)
      }, /*#__PURE__*/React.createElement(QuestionAnswerOutlined, {
        className: "qa-icon"
      }), /*#__PURE__*/React.createElement("div", null, "\u554F\u984C\u53CD\u6620"))), isManagementMode && _.includes(rights, 'evms.audit.log.statistics') && /*#__PURE__*/React.createElement(AuditLogStatistics, {
        onClick: this.handleOpenAuditLogStatisticsSearchDialog.bind(this)
      })), /*#__PURE__*/React.createElement("div", {
        className: cx('slide-icon', {
          'arrowRight': !openSideMenu
        }),
        onClick: function onClick() {
          return onSetOpenSideMenu(!openSideMenu);
        }
      }, openSideMenu ? /*#__PURE__*/React.createElement(ArrowLeftIcon, null) : /*#__PURE__*/React.createElement(ArrowRightIcon, null))), /*#__PURE__*/React.createElement("div", {
        id: "g-content",
        className: cx({
          'closeSideMenu': !openSideMenu
        })
      }, children), resetPasswordUserName && /*#__PURE__*/React.createElement(ResetPassword, {
        userName: resetPasswordUserName,
        onClose: this.handleResetPassword.bind(this)
      }), openTerminalsRelatedEditor && /*#__PURE__*/React.createElement(TerminalsRelated, {
        isOpen: openTerminalsRelatedEditor,
        onClose: this.handleRelatedTerminalsEditor.bind(this)
      }), openLogisticsRelatedEditor && /*#__PURE__*/React.createElement(LogisticsRelated, {
        isOpen: openLogisticsRelatedEditor,
        onClose: this.handleRelatedLogisticsEditor.bind(this)
      }), openLoginDialog && /*#__PURE__*/React.createElement(LoginDialog, {
        onClose: this.handleOpenLoginDialog.bind(this)
      }), auditLogError && /*#__PURE__*/React.createElement(AuditLogErrorMessage, null), /*#__PURE__*/React.createElement(FeedbackEdit, {
        dialogData: feedbackDialogData,
        onClose: this.closeFeedbackDailog.bind(this)
      }));
    }
  }]);

  return App;
}(React.Component);

App.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  session: PropTypes.object,
  contextRoot: PropTypes.string,
  copyright: PropTypes.string,
  version: PropTypes.string,
  onSessionChange: PropTypes.func.isRequired,
  children: PropTypes.node,
  query: PropTypes.object,
  onLocationChange: PropTypes.func,
  onSetRights: PropTypes.func,
  onSetEnvCfg: PropTypes.func
};
App.childContextTypes = {
  path: PropTypes.string,
  menus: PropTypes.arrayOf(PropTypes.object),
  rights: PropTypes.arrayOf(PropTypes.string),
  pages: PropTypes.object,
  userId: PropTypes.string,
  userName: PropTypes.string,
  displayName: PropTypes.string,
  contextRoot: PropTypes.string,
  query: PropTypes.object,
  location: PropTypes.object,
  isManagementMode: PropTypes.bool
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$toJS = state.toJS(),
      session = _state$toJS.sessionObj,
      envCfg = _state$toJS.envCfg,
      app = _state$toJS.app;

  var alarmSoundOn = app.alarmSoundOn,
      openSideMenu = app.openSideMenu,
      marqueesData = app.marqueesData,
      auditLogError = app.auditLogError,
      feedbackDescription = app.feedbackDescription;
  return {
    session: session,
    query: {
      lng: envCfg.lng
    },
    contextRoot: envCfg.contextRoot,
    copyright: envCfg.copyright,
    version: envCfg.version,
    isManagementMode: envCfg.isManagementMode,
    alarmSoundOn: alarmSoundOn,
    openSideMenu: openSideMenu,
    marqueesData: marqueesData,
    auditLogError: auditLogError,
    feedbackDescription: feedbackDescription
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSessionChange: function onSessionChange(session) {
      dispatch(setSession(session));
    },
    onLocationChange: function onLocationChange(location, action) {
      dispatch(locationChange(location, action));
    },
    onSetRights: function onSetRights(rights) {
      dispatch(setRights(rights));
    },
    onSetEnvCfg: function onSetEnvCfg(contextRoot) {
      ah.get(contextRoot + '/system-config/list/all').then(function (result) {
        if (result.code < 0) throw new Error(result.error);
        var newEnvCfg = {};

        _.forEach(result.data.content, function (cfg) {
          _.set(newEnvCfg, _.camelCase(_.split(cfg.key, '.')), cfg.value);
        });

        dispatch(setEnvCfg(newEnvCfg));
      });
    },
    onGetAreaZones: function onGetAreaZones(contextRoot) {
      return getAreaZones(contextRoot, true).then(function (result) {
        var zonesList = _.map(result.content, function (el) {
          return {
            value: el.id,
            text: el.name
          };
        });

        dispatch(setZonesList(zonesList));
        dispatch(setZonesListData(result.content));
      });
    },
    onGetAreaTerminals: function onGetAreaTerminals(contextRoot) {
      return getAreaTerminals(contextRoot, true, null, null, 0, null, null, true).then(function (result) {
        var terminalsList = _.map(result.content, function (el) {
          return {
            value: el.id,
            text: el.name,
            zoneId: el.zoneId
          };
        });

        dispatch(setTerminalsList(terminalsList));
      });
    },
    onGetAllAreaTerminals: function onGetAllAreaTerminals(contextRoot) {
      return getAreaTerminals(contextRoot, true).then(function (result) {
        var terminalsList = _.map(result.content, function (el) {
          return {
            value: el.id,
            text: el.name,
            zoneId: el.zoneId
          };
        });

        dispatch(setAllTerminalsList(terminalsList));
      });
    },
    onGetLogistics: function onGetLogistics(contextRoot) {
      return getLogistics(contextRoot, true, null, null, null, true).then(function (result) {
        var logisticsList = _.map(result.content, function (el) {
          return {
            value: _.trim(el.id),
            text: el.name
          };
        });

        dispatch(setLogisticsList(logisticsList));
      });
    },
    onGetAllLogistics: function onGetAllLogistics(contextRoot) {
      return getLogistics(contextRoot, true).then(function (result) {
        var allLogisticsList = _.map(result.content, function (el) {
          return {
            value: _.trim(el.id),
            text: el.name
          };
        });

        dispatch(setAllLogisticsList(allLogisticsList));
      });
    },
    onGetAreaGates: function onGetAreaGates(contextRoot) {
      return getAreaGates(contextRoot, true).then(function (result) {
        var list = _.map(result.content, function (el) {
          return {
            value: _.trim(el.id),
            text: el.name
          };
        });

        dispatch(setGateList(list));
      });
    },
    onSetOpenSideMenu: function onSetOpenSideMenu(val) {
      return dispatch(setOpenSideMenu(val));
    },
    onGetMessageList: function onGetMessageList(contextRoot) {
      return getMessageListNotEnd(contextRoot, true).then(function (result) {
        var now = Date.now();
        var messageList = result.content.filter(function (o) {
          var begin = new Date(o.beginTime);
          var end = o.endTime ? new Date(o.endTime) : null;
          return begin <= now && (!end || end >= now);
        }).map(function (el) {
          return {
            id: el.id,
            title: el.title,
            description: el.description,
            source: el.source,
            linkUrl1: el.linkUrl1,
            linkUrl2: el.linkUrl2,
            linkUrl3: el.linkUrl3,
            linkName1: el.linkName1,
            linkName2: el.linkName2,
            linkName3: el.linkName3,
            pdfPath1: el.pdfPath1,
            imagePath1: el.imagePath1,
            imagePath2: el.imagePath2,
            imagePath3: el.imagePath3
          };
        });
        dispatch(setMarqueesData(messageList));
      });
    },
    onSetMarqueesData: function onSetMarqueesData(newMessageList) {
      dispatch(setMarqueesData(newMessageList));
    },
    onCloseTrafficLiveTab: function onCloseTrafficLiveTab() {
      dispatch(setOpenTrafficLiveTab(false));
    },
    onSetIsMobileDevice: function onSetIsMobileDevice() {
      dispatch(setIsMobileDevice(true));
    },
    onSetAuditLogErrorTrue: function onSetAuditLogErrorTrue() {
      dispatch(setAuditLogError(true));
    },
    onGetFeedbackDescription: function onGetFeedbackDescription(contextRoot) {
      return getFeedbackDescriptionAPI(contextRoot, true).then(function (result) {
        dispatch(setFeedbackDescription(result));
      });
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));